import { combineReducers } from 'redux';
import kitchenPrepWorksheetListState from './kitchenPrepWorksheet/reducer';
import createEditKitchenPrepWorksheetState from './createEditKitchenPrepWorksheet/reducer';
import tabSettingsState from './settings/reducer';
import availableKitchenPrepWorksheetState from './availableKitchenPrepWorksheet/reducer';

export default combineReducers({
  kitchenPrepWorksheetListState,
  createEditKitchenPrepWorksheetState,
  tabSettingsState,
  availableKitchenPrepWorksheetState,
});



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/reducers.js